export const legalAgreementsContactEs = {
  legalAgreements_contactTitle: "¿Preguntas sobre estos acuerdos?",
  legalAgreements_contactText:
    "Si tienes preguntas sobre Jandi o sobre estos acuerdos, escríbenos:",
  legalAgreements_contactAddress:
    "Jandi PR LLC · PO Box 1291 · San Lorenzo, PR 00754",
};
